module.exports = __webpack_public_path__ + "img/06-1.6d5f393e.png";